import {} from "../baseStyles.jsx";

const profileButtonStyle = (theme) => ({
	smallAvatar: {
		width: 28,
		height: 28,
	},
	accountButton: {
		textTransform: "none",
		fontWeight: 400,
		paddingLeft: 0,
	},
});
export default profileButtonStyle;
